import { defineMessages } from "react-intl";

export const messages = defineMessages({
    fileUpload: {
        id: "api.general.file-upload",
        defaultMessage: "File upload",
    },
    downloadButtonExt: {
        id: "api.button.download-ext",
        defaultMessage: "Download [.{ext}]",
    },
});
